export default {
  feedbackHeader: 'Submit Feedback',
  back: 'Back',
  revert: 'Revert',
  instruction:
    'Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help.',
  fillForm: 'Please fill in the form below and click ',
  useMailBox: ' or directly use your mailbox and send your request to ',
  email: 'Your email address',
  reply: '(so we can reply to you)',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: 'Feedback topic',
  topicPlaceHolder: 'Please select an option',
  bugReport: 'Bug report',
  featureRequest: 'Feature request',
  others: 'Others',
  subject: 'Subject',
  subjectPlaceHolder: 'Let us know how we can help you',
  description: 'Full description',
  descriptionPlaceHolder: 'Please include as much information as possible',
  send: 'Send Your Feedback',
} as const;
